
































import Vue, { PropType } from 'vue';
import _moderation from '../../services/endpoints/moderation';
import { ModRaid } from "models/Raid";

export default Vue.extend({
	name: "ModRaidEntfernen",
	props: {
		disabled: Boolean,
		raid: Object as PropType<ModRaid>
	},
	data: () => ({
		dialog: false
	}),
	methods: {
		removeRaid: async function(): Promise<void> {
			await _moderation.removeRaid(this.raid.id, this.raid.name);
			this.dialog = false;
			this.$emit('refreshRaids')
		}
	}
})
